import React, { useEffect, useState } from "react";
import ReactSelectField from "../../Input/react-select-field";
import RadioField from "../../Input/radio-field";
import TextField from "../../Input/text-field";

interface StratigraphicStratigraphySelectorProps {
  stratigraphyOptions: { value: string; label: string }[];  
  topOffsetType: number;
  topOffset: number;
  topOffsetStratigraphyLexiconId: number;
  onChangeSelectedStratigraphyLexiconId: (value: number) => void;
  setTopOffset: (id: string, value: number) => void;
  setTopOffsetType: (id: string, value: number) => void;
  id: string;
}

const TopOffsetTypeText = 1;
const TopOffsetTypeDepth = 2;

const StratigraphicStratigraphySelector: React.FC<StratigraphicStratigraphySelectorProps> = ({
  stratigraphyOptions,  
  topOffsetStratigraphyLexiconId,
  topOffset,
  topOffsetType,
  id,
  setTopOffsetType,
  onChangeSelectedStratigraphyLexiconId,
  setTopOffset
}) => {

    //const [stratigraphicType, setStratigraphicType] = useState<any>(topOffsetType);
    const [stratigraphicDepth, setStratigraphicDepth] = useState<any>(null);

    // useEffect(() => {
    //     if (topOffsetType) {
    //         setStratigraphicType(topOffsetType);        
    //     }
    // }, [topOffsetType]);

    useEffect(() => {        
        if (topOffset) {
            setStratigraphicDepth(topOffset);
        }
    }, [topOffset]);
    

    const isDepthMode = Number(topOffsetType) === TopOffsetTypeDepth;
    const isStratigraphyMode = !isDepthMode;

    const onBlurStratigraphicDepth = (event: any) => {        
        const value = parseFloat(event.target.value);
        if (!isNaN(value)) {
          setTopOffset(id, value);
        }
      };


  return (
    <div>
    <label className='label'>Align Stratigraphic Surface</label>
    <RadioField label="Stratigraphy Lexicon" group="Stratigraphic" checked={isStratigraphyMode} onChange={(e: any) => setTopOffsetType(id, TopOffsetTypeText)} />
    <RadioField label="Depth" group="Stratigraphic" checked={isDepthMode} onChange={(e: any) => setTopOffsetType(id, TopOffsetTypeDepth)}  />
    {isStratigraphyMode && <ReactSelectField label="Stratigraphy Lexicon" options={stratigraphyOptions} value={topOffsetStratigraphyLexiconId} onChange={onChangeSelectedStratigraphyLexiconId} />}
    {isDepthMode &&  <TextField label="Depth" type="number" onChange={setStratigraphicDepth} value={stratigraphicDepth} onBlur={onBlurStratigraphicDepth} />}

  </div>      
  );
};

export default StratigraphicStratigraphySelector;